import { connect } from 'react-redux'
import { values } from 'lodash'
import BillingAccountField from './BillingAccountField'
import { getBillingAccounts } from '../Billing.actions'
import showBillingCreateFormModal from '../BillingCreateFormModal'

const stateToProps = ({ billing: { billingAccounts } }) => ({
  billingAccounts: values(billingAccounts),
})

const dispatchToProps = {
  getBillingAccounts,
  showBillingCreateFormModal,
}

export default connect(stateToProps, dispatchToProps)(BillingAccountField)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountField/BillingAccountField.container.jsx